// import {envConfig} from './envConfig';

//Local
// const apiBaseUrl = envConfig.apiBaseUrl;
// const apiBaseUrl = "https://localhost:44354/";
// const URL = "https://localhost:44354";

//DEV
// const apiBaseUrl =
//   "https://corp-itcmap-cms-api-edf0fnf6ebgka3ac.centralindia-01.azurewebsites.net/";
// const URL =
//   "https://corp-itcmap-cms-api-edf0fnf6ebgka3ac.centralindia-01.azurewebsites.net";

//UAT
// const apiBaseUrl =
//   "https://appsvc-corp-itcmap-uat-api-dmhchfh0ccfdhvgj.centralindia-01.azurewebsites.net/";
// const URL =
//   "https://appsvc-corp-itcmap-uat-api-dmhchfh0ccfdhvgj.centralindia-01.azurewebsites.net";

//PROD
const apiBaseUrl =
  "https://appsvc-corp-itcmap-prod-api-d0cvd2avcdctdkfz.centralindia-01.azurewebsites.net/";
const URL =
  "https://appsvc-corp-itcmap-prod-api-d0cvd2avcdctdkfz.centralindia-01.azurewebsites.net";

export const appConfig = {
  serviceUrls: {
    uploadIntroductoryVideo: `${apiBaseUrl}api/v1/IntroductoryVideo/upload`,
    getIntroductoryVideo: `${apiBaseUrl}api/v1/IntroductoryVideo/latest`,
    updateIntroductoryVideo: `${apiBaseUrl}api/v1/IntroductoryVideo/update`,
    deleteIntroductoryVideo: `${apiBaseUrl}api/v1/IntroductoryVideo`,
    commonURL: `${URL}`,
    saveCategory: `${URL}/api/admin/categories`,
    getAdminEntries: `${URL}/api/admin`,
    saveIndiaEntries: `${URL}/api/admin/India`,
    saveIndiaPDFEntries: `${URL}/api/IndiaPdf`,
    saveIndiaImageEntries: `${URL}/api/IndiaImage`,
    saveStateEntries: `${URL}/api/admin/Statelevel`,
    saveStatePDFEntries: `${URL}/api/statedata`,
    saveStateImageEntries: `${URL}/api/statedataImage`,
    saveLoginEntries: `${URL}/api/admin/login`,
    saveAuditEntries: `${URL}/api/admin/Audit`,
    getValidateUser: `${URL}/api/admin/validate`,
    getActiveState: `${URL}/api/admin/states`,
    getTokenURL: `${URL}/generate-sas`,
    getURLcontroller: `${URL}/api/Url`,
  },
  sasUrls: {
    // storageAccount: `https://corpitcmap.blob.core.windows.net?sp=rcw&st=2025-05-29T12:24:45Z&se=2125-05-29T20:24:45Z&spr=https&sv=2024-11-04&sr=c&sig=PyGovLlQ4zuB17Yxc7MYIedfGuaC62g4CYnvqD4S%2Bxc%3D`,
    //storageAccount: `https://stcorpituatcms.blob.core.windows.net?sp=rcw&st=2025-06-05T07:28:42Z&se=2125-06-05T15:28:42Z&spr=https&sv=2024-11-04&sr=c&sig=ffFpA%2FGhsnm1JCpADL5CaiByh02Dws5eOtfmqK2T87M%3D`,
  },
};
